// Bright, chunky card with a 2px border + 3D bottom edge. Hover springs up
// (see .se-card-hover in index.css). spineColor paints a fat color bar on top.
export default function Card({
  children,
  spineColor,
  hover = true,
  paperDeep = false,
  flat = false,
  onClick,
  as: Tag = "div",
  className = "",
  style,
  ...rest
}) {
  return (
    <Tag
      onClick={onClick}
      className={`${hover ? "se-card-hover " : ""}${className}`.trim()}
      style={{
        position: "relative",
        background: paperDeep ? "var(--paper-deep)" : "var(--surface, #fff)",
        border: "2px solid var(--border-2, #e5e5e5)",
        borderRadius: 16,
        boxShadow: flat ? "none" : "var(--shadow-card)",
        padding: 24,
        overflow: "hidden",
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}
      {...rest}
    >
      {spineColor && (
        <span
          aria-hidden="true"
          style={{
            position: "absolute",
            top: 0, left: 0, right: 0,
            height: 6,
            background: spineColor,
          }}
        />
      )}
      {children}
    </Tag>
  );
}
